module.exports = __webpack_public_path__ + "static/Abacus HR-cf514444225b8c6b1530d45fa78ef649.jpg";